import { CartService } from '@/common/services/cart/cart.service';
import { replaceByObject } from '@/common/utils/strings/replace.utils';
import { isValid } from '@/common/utils/validation/common.utils';
import {
    CartCoverages,
    CartRequest,
} from '@/core/domain/cart/models/cart-request.model';
import { CartResponse } from '@/core/domain/cart/models/cart-response.model';
import { CartRepository } from '@/core/domain/cart/repositories/cart.respository';
import { selectReservation } from '@/core/reservation/store/reservation.selector';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { first, Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CartImplRepository extends CartRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly store: Store,
        private cartService: CartService,
    ) {
        super();
    }

    override createCart(
        cartCoverages: CartCoverages[] = [],
    ): Observable<CartResponse> {
        return this.store.select(selectReservation).pipe(
            first(),
            switchMap((reservation: unknown) => {
                const returnBranchCode = _.get(
                    reservation,
                    'differentLocationSelected',
                );
                const cartRequest: CartRequest = {
                    sessionId: _.get(reservation, 'uuid', ''),
                    startDate: _.get(reservation, 'startDate', ''),
                    endDate: _.get(reservation, 'endDate', ''),
                    categoryCode: _.get(reservation, 'vehicle.code', ''),
                    branchCode: _.get(reservation, 'locationSelected', ''),
                    age: _.get(reservation, 'age', 25),
                    coverages: cartCoverages,
                    latitude: _.get(reservation, 'location.gps.latitude', ''),
                    longitude: _.get(reservation, 'location.gps.longitude', ''),
                };
                if (isValid(returnBranchCode)) {
                    cartRequest.returnBranchCode = returnBranchCode;
                }
                return this.http.post<CartResponse>(
                    [
                        environment.alamoApi.BASE_HOST,
                        environment.alamoApi.ENDPOINTS.cartInternational,
                    ].join('/'),
                    cartRequest,
                );
            }),
        );
    }

    override getCart(): Observable<CartResponse> {
        return this.store.select(selectReservation).pipe(
            first(),
            switchMap((reservation: unknown) => {
                return this.http.get<CartResponse>(
                    replaceByObject(
                        [
                            environment.alamoApi.BASE_HOST,
                            environment.alamoApi.ENDPOINTS.cart,
                        ].join('/'),
                        {
                            sessionId: _.get(reservation, 'uuid'),
                        },
                    ),
                );
            }),
            switchMap((cartResponse: CartResponse) => {
                this.cartService.cart = cartResponse.data;
                return of(cartResponse);
            }),
        );
    }
}
